<div class="video-header">
    <h2 mat-dialog-title>{{ data.titulo }}</h2>
    <button mat-icon-button (click)="cerrar()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="mat-typography">
    <div class="video-wrapper">
        <iframe *ngIf="safeUrl" [src]="safeUrl" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
        </iframe>

        <div *ngIf="!safeUrl" class="error-msg">
            <mat-icon color="warn">error_outline</mat-icon>
            <p>No se pudo cargar el video tutorial.</p>
        </div>
    </div>

    <div class="video-description">
        <p>{{ data.descripcion }}</p>
    </div>
</mat-dialog-content>